import Splide from '@splidejs/splide';

const EL = '.js-photo-carousel';
const BUTTON = '.js-PhotoCarouselBtn';

if (document.querySelector(EL)) {
  const slider = new Splide(EL, {
    pagination: false,
    arrows: true,
    gap: 10,
    autoWidth: true
  }).mount();

  if(document.querySelector(BUTTON)){
    document.querySelector(BUTTON).addEventListener('click', function(){
      document.querySelector(EL).querySelector('a').click()
    })
  }
}
